import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout, HeaderNavigation, IconSidebar } from "./layouts";

// Route Views
import Analytics from "./views/Analytics";
import OnlineStore from "./views/OnlineStore";
import BlogOverview from "./views/BlogOverview";
import UserProfile from "./views/UserProfile";
import UserProfileLite from "./views/UserProfileLite";
import EditUserProfile from "./views/EditUserProfile";
import Login from "./views/Login";
import Register from "./views/Register";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import ChangePassword from "./views/ChangePassword";
import Errors from "./views/Errors";
import Forbidden from "./views/Forbidden";
import TokenExpired from "./views/TokenExpired";

import Contracts from "./views/Contracts";
import ContractsForm from "./views/ContractsForm";
import ContractVehicleTable from "./views/ContractVehicle";

import SLAForm from "./views/SLAForm";

import Service from "./components/contracts/services/Service";

import AuthorizationMatrixVehicles from "./views/AuthorizationMatrixVehicles";
import AuthorizationMatricesTable from "./views/AuthorizationMatrices";
import authorizationMatrixForm from "./views/AuthorizationMatrixForm";
import AuthorizationMatrixAudit from "./views/AuthorizationMatrixAudit";

import Policies from "./views/Policies";
import PoliciesForm from "./views/PoliciesForm";
import PolicyVehicles from "./views/PolicyVehicles";
import PolicyAudit from "./views/PolicyAudit";

import Vehicles from "./views/Vehicles";
import VehicleForm from "./components/vehicles/VehicleForm";
import VehiclePricingHistory from "./components/vehicles/VehiclePricingHistory";
import VehiclesImport from "./components/vehicles/VehiclesImport";
import DueDates from "./components/vehicles/DueDates";
import VehicleHistory from "./views/VehicleHistory";

import Insurances from "./components/vehicles/Insurances/Insurances";
import InsuranceForm from "./components/vehicles/Insurances/InsuranceForm";
import Brokers from "./components/vehicles/Insurances/Brokers";
import Producers from "./components/vehicles/Insurances/Producers";

import Clients from "./components/contacts/Clients";
import ClientExposures from "./components/contacts/ClientExposures";
import ClientForm from "./components/contacts/ClientForm";
import ClientAudit from "./components/contacts/ClientAudit";
import ClientRouteCost from "./components/contacts/ClientRouteCost";
import ClientWorkOrderExpenseType from "./components/contacts/ClientWorkOrderExpenseType";
import ClientSubscriptions from "./components/contacts/ClientSubscriptions";

import ClientGroups from "./components/contacts/ClientGroups";
import ClientGroup from "./components/contacts/ClientGroup";

import ProviderForm from "./components/contacts/ProviderForm";
import Providers from "./components/contacts/Providers";
import ProviderAudit from "./components/contacts/ProviderAudit";
import TaxVerificationDateUpdate from "./components/contacts/TaxVerificationDateUpdate";

import SubContacts from "./components/contacts/SubContacts";
import SubContactForm from "./components/contacts/SubContactForm";
import SubContactAudit from "./components/contacts/SubContactAudit";
import SubContactImport from "./components/contacts/SubContactImport";

import SyncPending from "./views/SyncPending";
import WorkOrder from "./components/work-orders/WorkOrder";
import WorkOrders from "./components/work-orders/WorkOrders";
import WorkOrderAlerts from "./components/work-orders/WorkOrderAlerts";
import WorkOrderCalendar from "./components/work-orders/WorkOrderCalendar";
import WorkOrderImport from "./components/work-orders/WorkOrderImport";

import WorkOrderApproval from "./views/WorkOrderApproval";
import Brands from "./components/vehicles/Brands/Brands";
import BrandsForm from "./components/vehicles/Brands/BrandsForm";

import Models from "./components/vehicles/Models/Models";
import ModelsForm from "./components/vehicles/Models/ModelsForm";

import MaintenacePlans from "./components/maintenance-plans/MaintenancePlans";
import MaintenacePlan from "./components/maintenance-plans/MaintenancePlan";
import MaintenancePlanVersion from "./components/maintenance-plans/MaintenancePlanVersion";
import MaintenancePlansDueDates from "./components/maintenance-plans/MaintenancePlansDueDates";
import MaintenancePlanVersionImport from "./components/maintenance-plans/MaintenancePlanVersionImport";

import Users from "./components/users/Users";
import User from "./components/users/User";

import Roles from "./components/users/Roles";
import Rol from "./components/users/Rol";

import WorkOrderPendingVoucher from "./components/work-orders/WorkOrderPendingVoucher";
import Vouchers from "./components/vouchers/Vouchers";
import PendingVouchers from "./components/vouchers/PendingVouchers";
import PendingCuitVerification from "./components/vouchers/PendingCuitVerification";
import CuitVerification from "./components/vouchers/CuitVerification";
import MultipleVoucher from "./components/vouchers/MultipleVoucher";

import Blank from "./views/Blank";

import Home from "./views/Home";
import SubcontactUser from "./components/contacts/SubcontactUser";
import PushNotification from "./views/PushNotification";
import MobileUsers from "./components/users/MobileUsers";
import Crons from "./views/Crons";
import VehiclesZipImport from "./components/vehicles/VehiclesZipImport";
import ProviderUser from "./components/contacts/ProviderUser";
import VehiclesAttachments from "./components/vehicles/VehiclesAttachments";
import ProviderVouchers from "./components/vouchers/ProviderVouchers";
import ProviderUsers from "./components/users/ProviderUsers";
import Reports from "./components/reporting/Reports";
import ReportStatus from "./components/reporting/Report";
import BookingCalendar from "./components/common/bookings/Calendar";
import BookingQuoteView from "./views/BookingQuote";
import BookingQuotesView from "./views/BookingQuotes";
import BookingView from "./views/Booking";
import BookingsView from "./views/Bookings";
import VehiclesGroupedByState from "./components/vehicles/GroupedByState";
import Tasks from "./components/tasks/Tasks";
import TaskView from "./views/Task";
import ACVehiclesTable from "./views/ACVehiclesTable";
import InvoinceView from "./views/InvoinceView";
import InvoincesView from "./views/InvoicesView";
import InvoicingSchedulesView from "./views/InvoicingSchedulesView";
import InvoicingScheduleView from "./views/InvoicingScheduleView";
import ServiceChangeVehiclesView from "./views/ServiceChargeVehiclesView";
import ClientChargeInvoicesView from "./views/ClientChargeInvoices";
import ClientInvoicingConfigsView from "./views/ClientInvoicingConfigsView";
import ClientInvoicingConfigView from "./views/ClientInvoicingConfigView";
import CreditNoteView from "./views/CreditNoteView";
import CreditNotesView from "./views/CreditNotesView";
import SAPProjectView from "./views/SAPProjectView";
import SAPProjectsView from "./views/SAPProjectsView";
import BookingPriceChangesImport from "./components/common/bookings/BookingPriceChangesImport";
import DebitNoteView from "./views/DebitNoteView";
import DebitNotesView from "./views/DebitNotesView";
import RebatesView from "./views/Rebates";
import DashboardUsers from "./components/users/DashboardUsers";
import DashboardUser from "./components/contacts/DashboardUser";
import WorkOrderCheckListView from "./views/WorkOrderChecklist";
import TrackingMap from "./components/vehicles/TrackingMap";
import BookingTelepaseTollsView from "./views/BookingTelepaseToll";
import GeodefenderFinesImport from "./components/common/geodefender-fines/GeodefenderFinesImport";
import GeodefenderFines from "./components/common/geodefender-fines/GeodefenderFines";

const BlankIconSidebarLayout = ({ children }) => (
  <IconSidebar noNavbar noFooter includeScripts={false}>
    {children}
  </IconSidebar>
);

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/login" />
  },
  {
    path: "/home",
    exact: true,
    layout: DefaultLayout,
    component: Home,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/contracts",
    exact: true,
    layout: DefaultLayout,
    component: Contracts,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/contracts/new",
    exact: true,
    layout: DefaultLayout,
    component: ContractsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/contracts/edit",
    exact: true,
    layout: DefaultLayout,
    component: ContractsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/contracts/view",
    exact: true,
    layout: DefaultLayout,
    component: ContractsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/SLA",
    exact: true,
    layout: DefaultLayout,
    component: SLAForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/services/:contract_id",
    exact: true,
    layout: DefaultLayout,
    component: Service,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/service-charge/:id/vehicles",
    exact: true,
    layout: DefaultLayout,
    component: ServiceChangeVehiclesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client-charge-invoices/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientChargeInvoicesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client-charge-invoices",
    exact: true,
    layout: DefaultLayout,
    component: ClientChargeInvoicesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client-invoicing-configs",
    exact: true,
    layout: DefaultLayout,
    component: ClientInvoicingConfigsView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client-invoicing-configs/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientInvoicingConfigsView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client-invoicing-config/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientInvoicingConfigView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/SLA/view",
    exact: true,
    layout: DefaultLayout,
    component: SLAForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/authorizationMatrices/new",
    exact: true,
    layout: DefaultLayout,
    component: authorizationMatrixForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/authorizationMatrices/edit",
    exact: true,
    layout: DefaultLayout,
    component: authorizationMatrixForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/authorizationMatrices/view",
    exact: true,
    layout: DefaultLayout,
    component: authorizationMatrixForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/authorizationMatrixAudit",
    exact: true,
    layout: DefaultLayout,
    component: AuthorizationMatrixAudit,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/authorizationMatrices",
    exact: true,
    layout: DefaultLayout,
    component: AuthorizationMatricesTable,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/ac-vehicles",
    exact: true,
    layout: DefaultLayout,
    component: ACVehiclesTable,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/contractVehicles",
    exact: true,
    layout: DefaultLayout,
    component: ContractVehicleTable,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/authorizationMatrixVehicles",
    layout: DefaultLayout,
    component: AuthorizationMatrixVehicles,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/policies",
    exact: true,
    layout: DefaultLayout,
    component: Policies,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/policies/new",
    exact: true,
    layout: DefaultLayout,
    component: PoliciesForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/policies/edit",
    exact: true,
    layout: DefaultLayout,
    component: PoliciesForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/policies/view",
    exact: true,
    layout: DefaultLayout,
    component: PoliciesForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/policyVehicles",
    exact: true,
    layout: DefaultLayout,
    component: PolicyVehicles,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/policyAudit",
    exact: true,
    layout: DefaultLayout,
    component: PolicyAudit,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicles",
    exact: true,
    layout: IconSidebar,
    component: Vehicles,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicles-grouped",
    exact: true,
    layout: DefaultLayout,
    component: VehiclesGroupedByState,
    private: false,
    roles: ["super-admin"]
  },

  {
    path: "/tracking-map",
    exact: true,
    layout: DefaultLayout,
    component: TrackingMap,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicles/new",
    exact: true,
    layout: DefaultLayout,
    component: VehicleForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicles/:contract_id/:is_update/:need_hansa_update/import",
    exact: true,
    layout: DefaultLayout,
    component: VehiclesImport,
    private: false,
    roles: ["super-admin"]
    //component: () => <Redirect to="/notFound" />
  },
  {
    path: "/vehicles/import/zip",
    exact: true,
    layout: DefaultLayout,
    component: VehiclesZipImport,
    private: false,
    roles: ["super-admin"]
    //component: () => <Redirect to="/notFound" />
  },
  {
    path: "/vehicles/attachments",
    exact: true,
    layout: DefaultLayout,
    component: VehiclesAttachments,
    private: false,
    roles: ["super-admin"]
    //component: () => <Redirect to="/notFound" />
  },
  {
    path:
      "/vehicles/:contract_id/:is_update/:need_hansa_update/import/:is_ac_car",
    exact: true,
    layout: DefaultLayout,
    component: VehiclesImport,
    private: false,
    roles: ["super-admin"]
    //component: () => <Redirect to="/notFound" />
  },
  {
    path: "/vehicle/edit/:id",
    exact: true,
    layout: DefaultLayout,
    component: VehicleForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicle/:id/pricing-history",
    exact: true,
    layout: DefaultLayout,
    component: VehiclePricingHistory,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicle/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: VehicleForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicles/expirations",
    exact: true,
    layout: DefaultLayout,
    component: DueDates,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vehicle-history/:plate",
    exact: true,
    layout: DefaultLayout,
    component: VehicleHistory,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/clients",
    exact: true,
    layout: DefaultLayout,
    component: Clients,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client-exposures",
    exact: true,
    layout: DefaultLayout,
    component: ClientExposures,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/clients/new",
    exact: true,
    layout: DefaultLayout,
    component: ClientForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client/edit/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: ClientForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client_groups",
    exact: true,
    layout: DefaultLayout,
    component: ClientGroups,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client_groups/new",
    exact: true,
    layout: DefaultLayout,
    component: ClientGroup,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client_group/edit/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientGroup,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client_group/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: ClientGroup,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/clients/audit/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientAudit,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client_routes/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientRouteCost,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client_expenses/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientWorkOrderExpenseType,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/client_subscriptions/:id",
    exact: true,
    layout: DefaultLayout,
    component: ClientSubscriptions,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/providers/new",
    exact: true,
    layout: DefaultLayout,
    component: ProviderForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/providers",
    exact: true,
    layout: DefaultLayout,
    component: Providers,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/providers/user/:subcontact_id",
    exact: true,
    layout: DefaultLayout,
    component: ProviderUser,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/providers/audit/:id",
    exact: true,
    layout: DefaultLayout,
    component: ProviderAudit,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/provider/edit/:id",
    exact: true,
    layout: DefaultLayout,
    component: ProviderForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/provider/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: ProviderForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/providers/audit/:id",
    exact: true,
    layout: DefaultLayout,
    component: ProviderAudit,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/subcontacts/:contact_id",
    exact: true,
    layout: DefaultLayout,
    component: SubContacts,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/subcontacts/subcontacts/:contact_id/:sub_contact_id/audit/",
    exact: true,
    layout: DefaultLayout,
    component: SubContactAudit,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/subcontacts/:contact_id/new/",
    exact: true,
    layout: DefaultLayout,
    component: SubContactForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/subcontacts/:contact_id/import/",
    exact: true,
    layout: DefaultLayout,
    component: SubContactImport,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/subcontacts/subcontact/:id",
    exact: true,
    layout: DefaultLayout,
    component: SubContactForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/subcontacts/subcontact/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: SubContactForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/brands",
    exact: true,
    layout: DefaultLayout,
    component: Brands,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/brands/new",
    exact: true,
    layout: DefaultLayout,
    component: BrandsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/brand/:id",
    exact: true,
    layout: DefaultLayout,
    component: BrandsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/brand/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: BrandsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/models/",
    exact: true,
    layout: DefaultLayout,
    component: Models,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/models/:brand_id",
    exact: true,
    layout: DefaultLayout,
    component: Models,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/models/:id/new",
    exact: true,
    layout: DefaultLayout,
    component: ModelsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/models/model/:id",
    exact: true,
    layout: DefaultLayout,
    component: ModelsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/models/model/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: ModelsForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/insurances/",
    exact: true,
    layout: DefaultLayout,
    component: Insurances,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/brokers/",
    exact: true,
    layout: DefaultLayout,
    component: Brokers,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/producers/",
    exact: true,
    layout: DefaultLayout,
    component: Producers,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/insurances/new",
    exact: true,
    layout: DefaultLayout,
    component: InsuranceForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/insurance/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: InsuranceForm,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/maintenance-plans/",
    exact: true,
    layout: DefaultLayout,
    component: MaintenacePlans,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/maintenance-plans/new",
    exact: true,
    layout: DefaultLayout,
    component: MaintenacePlan,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/maintenance-plan/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: MaintenacePlan,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/maintenance-plan-version/:id/:view",
    exact: true,
    layout: DefaultLayout,
    component: MaintenancePlanVersion,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/maintenance-plan-due-dates/:id/",
    exact: true,
    layout: DefaultLayout,
    component: MaintenancePlansDueDates,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/maintenance-plan-version-import/:maintenance_plan_id/",
    exact: true,
    layout: DefaultLayout,
    component: MaintenancePlanVersionImport,
    private: false,
    roles: ["super-admin"]
    //component: () => <Redirect to="/notFound" />
  },
  {
    path: "/users",
    exact: true,
    layout: DefaultLayout,
    component: Users,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/provider/users",
    exact: true,
    layout: DefaultLayout,
    component: ProviderUsers,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/mobile/users",
    exact: true,
    layout: DefaultLayout,
    component: MobileUsers,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/dashboard/users",
    exact: true,
    layout: DefaultLayout,
    component: DashboardUsers,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/users/new",
    exact: true,
    layout: DefaultLayout,
    component: User,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/user/:user_id/:view",
    exact: true,
    layout: DefaultLayout,
    component: User,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/mobile/user/:subcontact_id",
    exact: true,
    layout: DefaultLayout,
    component: SubcontactUser,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/dashboard/user/:subcontact_id",
    exact: true,
    layout: DefaultLayout,
    component: DashboardUser,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/roles",
    exact: true,
    layout: DefaultLayout,
    component: Roles,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/role/:role_id/:view",
    exact: true,
    layout: DefaultLayout,
    component: Rol,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/invoice/:id",
    exact: true,
    layout: IconSidebar,
    component: InvoinceView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/invoice/:id/:client_id",
    exact: true,
    layout: IconSidebar,
    component: InvoinceView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/invoices",
    exact: true,
    layout: DefaultLayout,
    component: InvoincesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/invoices/:id",
    exact: true,
    layout: IconSidebar,
    component: InvoincesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/invoicing-schedules",
    exact: true,
    layout: DefaultLayout,
    component: InvoicingSchedulesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/invoicing-schedule/new",
    exact: true,
    layout: DefaultLayout,
    component: InvoicingScheduleView,
    private: false,
    roles: ["administrative.admin"]
  },
  {
    path: "/credit-notes",
    exact: true,
    layout: DefaultLayout,
    component: CreditNotesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/debit-notes",
    exact: true,
    layout: DefaultLayout,
    component: DebitNotesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/credit-note/:id/:invoice_id",
    exact: true,
    layout: IconSidebar,
    component: CreditNoteView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/debit-note/:id/:invoice_id",
    exact: true,
    layout: IconSidebar,
    component: DebitNoteView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/sap-projects",
    exact: true,
    layout: DefaultLayout,
    component: SAPProjectsView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/sap-project/:id",
    exact: true,
    layout: DefaultLayout,
    component: SAPProjectView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vouchers",
    exact: true,
    layout: DefaultLayout,
    component: Vouchers,
    private: false,
    roles: ["super-admin"]
  },
  /*  {
    path: "/vouchers/new",
    exact: true,
    layout: DefaultLayout,
    component: PendingVouchers,
    private: false,
    roles: ['super-admin']
  },
  */
  {
    path: "/pending-cuit-verification/",
    exact: true,
    layout: DefaultLayout,
    component: PendingCuitVerification,
    private: true,
    roles: ["super-admin"]
  },
  {
    path: "/cuit-verification/:contact_id",
    exact: true,
    layout: DefaultLayout,
    component: CuitVerification,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/rebates",
    exact: true,
    layout: IconSidebar,
    component: RebatesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/providers/rebates/:provider_id",
    exact: true,
    layout: IconSidebar,
    component: RebatesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/vouchers/new",
    exact: true,
    layout: DefaultLayout,
    component: MultipleVoucher,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/work-orders-pending-vouchers",
    exact: true,
    layout: IconSidebar,
    component: WorkOrderPendingVoucher,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/reports",
    exact: true,
    layout: IconSidebar,
    component: Reports,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/report/:progress_id",
    exact: true,
    layout: IconSidebar,
    component: ReportStatus,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/provider-vouchers",
    exact: true,
    layout: IconSidebar,
    component: ProviderVouchers,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/analytics",
    layout: DefaultLayout,
    component: Analytics
  },
  {
    path: "/ecommerce",
    layout: DefaultLayout,
    component: OnlineStore
  },
  {
    path: "/blog-overview",
    layout: DefaultLayout,
    component: BlogOverview
  },
  {
    path: "/user-profile",
    layout: DefaultLayout,
    component: UserProfile
  },
  {
    path: "/user-profile-lite",
    layout: DefaultLayout,
    component: UserProfileLite
  },
  {
    path: "/edit-user-profile",
    layout: DefaultLayout,
    component: EditUserProfile
  },
  {
    path: "/login",
    layout: BlankIconSidebarLayout,
    component: Login,
    private: false
  },
  {
    path: "/register",
    layout: BlankIconSidebarLayout,
    component: Register
  },
  {
    path: "/forgot-password",
    layout: BlankIconSidebarLayout,
    component: ForgotPassword
  },
  {
    path: "/reset-password",
    layout: BlankIconSidebarLayout,
    component: ResetPassword
  },
  {
    path: "/change-password",
    layout: BlankIconSidebarLayout,
    component: ChangePassword
  },
  {
    path: "/work-orders/",
    exact: true,
    layout: IconSidebar,
    component: WorkOrders,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/work-orders/calendar",
    exact: true,
    layout: DefaultLayout,
    component: WorkOrderCalendar,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/bookings/calendar",
    exact: true,
    layout: DefaultLayout,
    component: BookingCalendar,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/bookings/quote/:id",
    exact: true,
    layout: IconSidebar,
    component: BookingQuoteView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/bookings/quotes",
    exact: true,
    layout: IconSidebar,
    component: BookingQuotesView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/bookings",
    exact: true,
    layout: IconSidebar,
    component: BookingsView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/booking/:id",
    exact: true,
    layout: IconSidebar,
    component: BookingView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/booking-telepase-tolls/:id",
    exact: true,
    layout: IconSidebar,
    component: BookingTelepaseTollsView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/bookings/price-changes/import",
    exact: true,
    layout: DefaultLayout,
    component: BookingPriceChangesImport
  },
  {
    path: "/work-orders/alerts",
    exact: true,
    layout: DefaultLayout,
    component: WorkOrderAlerts,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/work-order/:id",
    exact: true,
    layout: IconSidebar,
    component: WorkOrder,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/work-order-checklist/:id",
    exact: true,
    layout: IconSidebar,
    component: WorkOrderCheckListView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/work-orders/import",
    exact: true,
    layout: DefaultLayout,
    component: WorkOrderImport,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/work-order-approval/:id",
    exact: true,
    layout: BlankIconSidebarLayout,
    component: WorkOrderApproval,
    private: false,
    roles: []
  },
  {
    path: "/contact/update-verification-date/:contact_id",
    exact: true,
    layout: DefaultLayout,
    component: TaxVerificationDateUpdate,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/tasks",
    exact: true,
    layout: DefaultLayout,
    component: Tasks,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/tasks-non-productive",
    exact: true,
    layout: DefaultLayout,
    component: Tasks,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/tasks/:id/:is_productive",
    exact: true,
    layout: DefaultLayout,
    component: TaskView,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/geodefender-fines",
    exact: true,
    layout: DefaultLayout,
    component: GeodefenderFines,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/geodefender-fines/import",
    exact: true,
    layout: DefaultLayout,
    component: GeodefenderFinesImport,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/geodefender-fines/:id",
    exact: true,
    layout: DefaultLayout,
    component: GeodefenderFines,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/hansa-pending-sync",
    exact: true,
    layout: DefaultLayout,
    component: SyncPending
  },
  {
    path: "/crons",
    exact: true,
    layout: DefaultLayout,
    component: Crons,
    roles: ["efleet-admin"]
  },
  {
    path: "/push/notification/:user_id",
    exact: true,
    layout: DefaultLayout,
    component: PushNotification,
    private: false,
    roles: ["super-admin"]
  },

  /*
  {
    path: "/ot",
    exact: true,
    layout: DefaultLayout,
    component: OT
  },
  {
    path: "/ot/new",
    exact:true,
    layout: DefaultLayout,
    component: OTForm
  },
  {
    path: "/ot2/new",
    exact:true,
    layout: DefaultLayout,
    component: OTForm2
  },
  {
    path: "/file-manager-list",
    layout: DefaultLayout,
    component: FileManagerList
  },
  {
    path: "/file-manager-cards",
    layout: DefaultLayout,
    component: FileManagerCards
  },
  {
    path: "/transaction-history",
    layout: DefaultLayout,
    component: TransactionHistory
  },
  {
    path: "/calendar",
    layout: IconSidebar,
    component: Calendar
  },
  {
    path: "/add-new-post",
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/errors",
    layout: BlankIconSidebarLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/tables",
    layout: DefaultLayout,
    component: Tables
  },
  {
    path: "/blog-posts",
    layout: DefaultLayout,
    component: BlogPosts
  },
  {
    path: "/header-navigation",
    layout: HeaderNavigation,
    component: HeaderNav
  },
  {
    path: "/icon-sidebar-nav",
    layout: IconSidebar,
    component: IconSidebarView
  },*/
  {
    path: "/notFound",
    exact: false,
    layout: BlankIconSidebarLayout,
    component: Errors
  },
  {
    path: "/token-expired",
    exact: false,
    layout: BlankIconSidebarLayout,
    component: TokenExpired
  },
  {
    path: "/forbidden",
    exact: false,
    layout: BlankIconSidebarLayout,
    component: Forbidden
  },
  {
    path: "/*",
    exact: false,
    layout: DefaultLayout,
    component: () => <Redirect to="/notFound" />
  }
];
